module.exports = __webpack_public_path__ + "img/sword-poseidon.07f0e95b.jpg";